"use client";
import "yet-another-react-lightbox/styles.css";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import PhotoAlbum from "react-photo-album";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import React, { useState } from "react";
import photos from "@/lib/photos";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import SeoMetaData from "@/components/SeoMetaData";
import { Helmet } from "react-helmet-async";

export default function Galeria() {
  const [index, setIndex] = useState(-1);

  return (
    <>
      <Helmet>
        <title>Galéria | BeArt Művészetterápia</title>
        <meta name="description" content="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások" />
        <meta property="og:title" content="Galéria | BeArt Művészetterápia" />
        <meta property="og:description" content="BeArt Művészetterápia galéria - művészetterápiás csoportok, egyéni és csoportos alkalmak" />
        <link rel="canonical" href="https://beart.hu/galeria" />
      </Helmet>
      
      <SeoMetaData
        seoTitle="Galéria | BeArt Művészetterápia"
        seoDescription="BeArt Művészetterápia, Art Coaching, családállítás, coaching, önismeret - művészetterápiás csoportok, egyéni és csoportos alkalmak, szervezeteknek kiégés megelőzés programok, önismereti foglalkozások"
      />
      <div>
        <h1 className="mx-auto mb-8 mt-10 flex w-full justify-center text-center text-3xl font-bold">
          <i className="bi bi-images mr-2"></i>Galéria
        </h1>
        <PhotoAlbum
          photos={photos}
          layout="masonry"
          targetRowHeight={150}
          onClick={({ index }) => setIndex(index)}
        />
        <Lightbox
          slides={photos}
          open={index >= 0}
          index={index}
          close={() => setIndex(-1)}
          plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
        />
      </div>
    </>
  );
}
